import type { CustomBaseDataType } from '../interface';
import type { IModelSource } from '../interface/db';
import type IFloorPlanDto from './FloorPlanDto.if';
import type IPinTypeDto from './PinTypeDto.if';
import type ISiteObjectDto from './SiteObjectDto.if';
import type ISiteObjectOnFloorPlanDto_Api from './SiteObjectOnFloorPlanDto.api';

export interface ISiteObjectOnFloorPlanDto_Linkables extends CustomBaseDataType {
    siteObject: (db: IModelSource) => Promise<ISiteObjectDto>;
    floorPlan: (db: IModelSource) => Promise<IFloorPlanDto>;
    pinType: (db: IModelSource) => Promise<IPinTypeDto>;
}

function _siteObject(
    this: Partial<ISiteObjectOnFloorPlanDto_Api>,
    db: IModelSource,
): Promise<ISiteObjectDto> {
    return this.siteObjectId
        ? db.get('ISiteObjectDto', this.siteObjectId)
        : Promise.reject(new Error('Missing field siteObjectOnFloorPlan.siteObjectId'));
}
function _floorPlan(
    this: Partial<ISiteObjectOnFloorPlanDto_Api>,
    db: IModelSource,
): Promise<IFloorPlanDto> {
    return this.floorPlanId
        ? db.get('IFloorPlanDto', this.floorPlanId)
        : Promise.reject(new Error('Missing field siteObjectOnFloorPlan.floorPlanId'));
}
function _pinType(
    this: Partial<ISiteObjectOnFloorPlanDto_Api>,
    db: IModelSource,
): Promise<IPinTypeDto> {
    return this.pinTypeId
        ? db.get('IPinTypeDto', this.pinTypeId)
        : Promise.reject(new Error('Missing field siteObjectOnFloorPlan.pinTypeId'));
}

/** 
 * @description all custom properties for
   SiteObjectOnFloorPlanDto & methods to link against other entities
*/
function linkables(
    model: Partial<ISiteObjectOnFloorPlanDto_Api>,
): ISiteObjectOnFloorPlanDto_Linkables {
    return {
        siteObject: _siteObject.bind(model),
        floorPlan: _floorPlan.bind(model),
        pinType: _pinType.bind(model),
    };
}

export default linkables;
